import React, { useEffect } from "react";
import { ThemeCard } from "../../components/ThemeCard";
import { allThemes } from "../../modules/themes";
import { CategoryType } from "../../modules/exercises.types";
import { filterThemesForProfile } from "../../core/accessControl";
import { useAuth } from "../../context/AuthContext";
import { MixmindUniverse, useUniverse } from "../../context/UniverseContext";

// Parcours Explorer (Academy) : thèmes éducatifs filtrés par profil si disponible.
export default function AcademyExplorer() {
  const { accessProfile } = useAuth();
  const { setUniverse } = useUniverse();
  useEffect(() => {
    setUniverse(MixmindUniverse.Academy);
  }, [setUniverse]);
  const rawThemes = allThemes.filter((t) => t.category === CategoryType.COMPRENDRE);
  const themes = filterThemesForProfile(rawThemes, accessProfile);

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Academy · Explorer</h1>
        <p className="text-sm md:text-base text-slate-700 dark:text-slate-300">
          Parcours thématiques pour nourrir la curiosité et découvrir l&apos;intelligence mixte. Les contenus
          s&apos;adaptent progressivement aux profils et aux âges.
        </p>
      </header>

      {themes.length > 0 && (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {themes.map((theme) => (
            <ThemeCard key={theme.id} theme={theme} />
          ))}
        </div>
      )}
      {themes.length === 0 && rawThemes.length > 0 && (
        <section className="space-y-2 text-sm">
          <h3 className="text-lg font-semibold">Aucun thème affiché pour ce profil</h3>
          <p className="text-slate-700 dark:text-slate-300">
            Mode découverte : tous les thèmes restent accessibles. Ajustez le profil ou la tranche d&apos;âge
            plus tard si besoin.
          </p>
          {/* TODO MixMind: ajouter un sélecteur d'âge/rôle pour simuler l'accès aux contenus. */}
        </section>
      )}
    </div>
  );
}
